export default __webpack_public_path__ + "fonts/Light-29f6c1.ttf";